import { Product } from 'entities/product';

// Observed USD→market conversion for a product: its market-localized Shopify
// variant amount over its always-USD plans amount. 1 in the US market or
// while variant data loads. Approximate by design — Shopify rounds market
// prices, so this ratio can differ slightly from the raw checkout FX rate.
export const getUsdToMarketRatio = (
  product?: Pick<Product, 'price' | 'shopifyData'> | null,
): number => {
  const shopifyAmount = parseFloat(product?.shopifyData?.price?.amount ?? '');
  const plansAmount = parseFloat(product?.price ?? '');
  return shopifyAmount > 0 && plansAmount > 0 ? shopifyAmount / plansAmount : 1;
};
